<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش تنوع ها</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span
            style="transform: translateY(3px)"
            class="feather-printer"
          ></span>
        </button>
        <ExcelDownload
          class="mr-2"
          url="admin/reports/varieties-list"
          :extraQuery="extraQuery"
        />
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="chrome-off"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-6">
            <DatePickerRange v-model="filter.date" />
          </div>
          <b-form-group class="col-4">
            <div class="d-flex">
              <label
                @click="() => (includeUnsold = includeUnsold ? 0 : 1)"
                class="ml-2"
                >محصولات فروخته نشده</label
              >
              <b-form-checkbox
                :unchecked-value="0"
                :disabled="disabled"
                :value="1"
                v-model="includeUnsold"
              />
            </div>
          </b-form-group>
          <b-form-group class="col-12" label="دسته بندی">
            <treeselect
              class="col-4"
              :options="realOptions"
              :multiple="true"
              v-model="category_ids"
              :searchable="true"
              :show-count="true"
              noChildrenText="فرزندی وجود ندارد"
              noOptionsText="موردی وجود ندارد"
              noResultsText="موردی یافت نشد"
              :default-expand-level="1"
              label="title"
            >
              <label
                slot="option-label"
                slot-scope="{
                  node,
                  shouldShowCount,
                  count,
                  labelClassName,
                  countClassName,
                }"
                :class="labelClassName"
              >
                {{ node.label }}
              </label>
            </treeselect>
          </b-form-group>
          <div class="col-12 d-flex justify-content-end">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
        <form autocomplete="off" class="mt-3 col-4">
          <b-form-group>
            <b-form-input v-model="filter.search" placeholder="جستجو" />
          </b-form-group>
        </form>
      </div>
      <div id="print" class="p-4">
        <div
          class="d-flex mb-3 mr-2-print"
          v-if="appliedFilter.date.startDate || appliedFilter.date.endDate"
        >
          <div v-if="appliedFilter.date.startDate">
            <span> از تاریخ</span
            ><span> {{ appliedFilter.date.startDate | persianDate }} </span>
          </div>
          <div class="mr-4" v-if="appliedFilter.date.endDate">
            <span> تا تاریخ</span
            ><span> {{ appliedFilter.date.endDate | persianDate }} </span>
          </div>
        </div>
        <div class="w-100 mt-1 mb-2 mr-2-print" v-if="filter.search">
          جستجوی عبارت "{{ filter.search }}"
        </div>
        <b-table
          @sort-changed="sortChanged"
          id="main-table"
          v-if="reports.length"
          bordered
          striped
          :fields="fields"
          :items="reports"
          :filter="filter.search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-included-fields="['title', 'id']"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            <!-- {{ data.index + 1 + (page - 1) * perPage }} -->
            {{ data.index + 1  }}
          </template>
          <template v-slot:cell(total_sale)="data">
            {{ data.item.total_sale | price }}
          </template>
          <template v-slot:cell(title)="data">
            <a
              target="_blank"
              :href="'/admin/products/edit/' + data.item.product.id"
              >{{ data.item.title }}</a
            >
          </template>
          <template v-slot:cell(center)="data">
            {{ renderStoreBalanceByStoreId(data.item, 1) }}
          </template>

          <template v-slot:cell(gorgan)="data">
            {{ renderStoreBalanceByStoreId(data.item, 2) }}
          </template>

          <template v-slot:cell(sari)="data">
            {{ renderStoreBalanceByStoreId(data.item, 3) }}
          </template>
        </b-table>
        <div class="text-center my-3" v-if="reports.length ">
          <button v-if="pagination" class="btn btn-primary" type="button" @click="changePagination">
            مشاهده بیشتر
          </button>
        </div>
        <div v-if="!reports.length" class="alert alert-primary">در حال بارگزاری</div>
      </div>
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import { getVarietyTitle } from "@@/core/libraries/functions";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import orderReportFilterMixin from "@@/core/components/report/orderReportFilterMixin";
import sortMixin from "@@/core/libraries/mixins/sortMixin";

function Filter() {
  this.search = "";
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "ProductsReport",
  components: {
    ExcelDownload,
    DatePickerRange,
    BFormCheckbox,
    Treeselect,
    BTable,
    BFormGroup,
    BFormInput,
    BPagination,
  },
  mixins: [orderReportFilterMixin, sortMixin],
  data() {
    return {
      activePage:1,
      disabled: true,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "product_id",
          label: "شناسه محصول",
          sortable: true,
        },
        {
          key: "title",
          label: "عنوان",
          sortable: true,
        },
        {
          key: "sell_quantity",
          label: "تعداد فروش",
          sortable: true,
        },
        {
          key: "total_sale",
          label: "میزان فروش (تومان)",
          sortable: true,
        },
      ],
      page: 1,
      categories: [],
      perPage: 100,
      previousPage: 1,
      includeUnsold: false,
      reports: [],
      // current_reports: [],
      category_ids: null,
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      pagination: {},
    };
  },
  created() {
    this.page = this.$route.query.page ?? 1;
    this.loadCategoriesData();
    this.loadData();
  },
  watch: {
    per_page() {
      this.changePage(1);
    },
  },

  computed: {
    realOptions() {
      let temp = this.$root.addLabel(this.categories);
      temp.unshift({
        label: "ندارد",
        children: [],
        id: 0,
      });

      return temp;
    },
    extraQuery() {
      return {
        start_date: this.filter.date.startDate,
        end_date: this.filter.date.endDate,
        page: this.page,
        per_page: this.per_page,
        ...this.getFilters(),
        ...this.getSortFilters(),
      };
    },
    totalRows() {
      return this.reports ? this.reports.data : 0;
    },
  },
  methods: {
     renderStoreBalanceByStoreId(item, storeId) {
      if (!item || !Array.isArray(item.store_items)) return "-";
      const entry = item.store_items.find(si => si.store_id === storeId);
      return entry && typeof entry.balance !== "undefined" ? entry.balance : "-";
    },
    async loadCategoriesData() {
      try {
        const response = await this.$axios.get("admin/categories", {
          params: { all: 1 },
        });
        this.categories = response.data.data.categories;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    changePagination(){
      this.page++
      const currentQuery = { ...this.$route.query }
    const newQuery = { ...currentQuery, page:this.page }

    console.log(newQuery,"activeQueryactiveQueryactiveQuery");
    this.$router.push({ path: this.$route.query.path, query: { ...newQuery } })

      console.log(this.$route,"activeQueryactiveQueryactiveQuery");
      this.loadData();

    },
    print() {
      print();
    },
    doFilter() {
      this.loadData("filter");
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    async loadData(type) {
      try {
        if(type=="filter"){
          this.reports=[]
        }
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/varieties-list", {
          params: {
            start_date: this.appliedFilter.date.startDate,
            end_date: this.appliedFilter.date.endDate,
            categories:
              this.category_ids && this.category_ids.length > 0
                ? this.category_ids
                : [],
            unsold_varieties:
              this.includeUnsold == true ? this.includeUnsold : "",
            page: this.page,
            per_page: this.per_page,
            ...this.getFilters(),
            ...this.getSortFilters(),
          },
        });
        this.pagination = response.data.data.pagination;
        this.currentPage = response.data.data.pagination.current_page;
        let Newreports = response.data.data.reports.map((v) => {
          v.title =
            v.product.title +
            " " +
            (v.name ? v.name + " " : "") +
            getVarietyTitle(v);
          return v;
        });
        
        // this.current_reports=[...this.current_reports, ...Newreports]
        
        this.reports=[...this.reports, ...Newreports]
        if (this.reports && this.includeUnsold) {
          this.fields = [
            {
              key: "index",
              label: "ردیف",
            },
            {
              key: "product_id",
              label: "شناسه محصول",
              sortable: true,
            },
            {
              key: "title",
              label: "عنوان",
              sortable: true,
            },
            {
              key: "center",
              label: "انبار مرکزی",
              sortable: true,
            },
            {
              key: "gorgan",
              label: "انبار گرگان",
              sortable: true,
            },
            {
              key: "sari",
              label: "انبار ساری",
              sortable: true,
            },
          ];
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
